import { useRecoilState } from 'recoil';
import { useEffect } from 'react';
import { DependencyContainer } from '../DependencyContainer';
import { apiVersionAtom } from '../state';

const { versionService } = new DependencyContainer();

export const useApiVersion = () => {
  const [apiVersion, setApiVersion] = useRecoilState(apiVersionAtom);

  const getVersion = async () => {
    const version = await versionService.getVersion();

    if (version) {
      console.log(`API version: ${version}`);
      setApiVersion(version);
    }
  };
  useEffect(() => {
    if (!apiVersion) {
      getVersion();
    }
  }, []);
};
